import {
  GET_DOCUMENT_RENEWALS, GET_DOCUMENT_RENEWALS_SUCCESS, GET_DOCUMENT_RENEWALS_FAILURE,
  GET_DOCUMENT_RENEWAL, GET_DOCUMENT_RENEWAL_SUCCESS, GET_DOCUMENT_RENEWAL_FAILURE,
  CONFIRM_DOCUMENT_RENEWAL, CONFIRM_DOCUMENT_RENEWAL_SUCCESS, CONFIRM_DOCUMENT_RENEWAL_FAILURE,
  REJECT_DOCUMENT_RENEWAL, REJECT_DOCUMENT_RENEWAL_SUCCESS, REJECT_DOCUMENT_RENEWAL_FAILURE
} from './mutation-types'
import constant from '../constant'

//
// 書類更新の確認（P12）
//
export default {
  state: {
    documentRenewals: null,
    documentRenewal: null,
    documentRenewalNotify: null,
    documentRenewalForbidden: false
  },
  getters: {
    documentRenewals: state => {
      return state.documentRenewals
    },
    documentRenewal: state => {
      return state.documentRenewal
    },
    documentRenewalNotify: state => {
      return state.documentRenewalNotify
    },
    documentRenewalForbidden: state => {
      return state.documentRenewalForbidden
    }
  },
  actions: {
    // 提出一覧
    [GET_DOCUMENT_RENEWALS] ({dispatch, state, commit}, params = null) {
      var data = {}
      if (params) {
        data = params.data
      }
      state.documentRenewalForbidden = false
      dispatch('apiGet', {url: '/master/document_renewals', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_DOCUMENT_RENEWALS_FAILURE, res.data)
          } else {
            commit(GET_DOCUMENT_RENEWALS_SUCCESS, {data: res.data, callback: params ? params.callback : null})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.documentRenewalForbidden = true
          commit(GET_DOCUMENT_RENEWALS_FAILURE, error.response.data)
          if (params && params.callback) params.callback()
          return
        }
        throw error
      })
    },
    // 詳細
    [GET_DOCUMENT_RENEWAL] ({dispatch, state, commit}, params) {
      state.documentRenewalForbidden = false
      dispatch('apiGet', {url: '/master/document_renewals/' + params.id, data: {}})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(GET_DOCUMENT_RENEWAL_FAILURE, res.data)
          } else {
            commit(GET_DOCUMENT_RENEWAL_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          state.documentRenewalForbidden = true
          commit(GET_DOCUMENT_RENEWAL_FAILURE, error.response.data)
          if (params.callback) params.callback()
          return
        }
        throw error
      })
    },
    // 確認して期限日を保存
    [CONFIRM_DOCUMENT_RENEWAL] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/document_renewals/' + params.id + '/confirm', data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(CONFIRM_DOCUMENT_RENEWAL_FAILURE, res.data)
          } else {
            commit(CONFIRM_DOCUMENT_RENEWAL_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        commit(CONFIRM_DOCUMENT_RENEWAL_FAILURE, {error: '保存に失敗しました。'})
        throw error
      })
    },
    // 差戻し
    [REJECT_DOCUMENT_RENEWAL] ({dispatch, state, commit}, params) {
      return dispatch('apiPost', {url: '/master/document_renewals/' + params.id + '/reject', data: params.data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(REJECT_DOCUMENT_RENEWAL_FAILURE, res.data)
          } else {
            commit(REJECT_DOCUMENT_RENEWAL_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        commit(REJECT_DOCUMENT_RENEWAL_FAILURE, {error: '差戻しに失敗しました。'})
        throw error
      })
    }
  },
  mutations: {
    [GET_DOCUMENT_RENEWALS_FAILURE] (state, data) {
      console.log('GET_DOCUMENT_RENEWALS_FAILURE')
      state.documentRenewals = []
    },
    [GET_DOCUMENT_RENEWALS_SUCCESS] (state, data) {
      console.log('GET_DOCUMENT_RENEWALS_SUCCESS')
      state.documentRenewals = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [GET_DOCUMENT_RENEWAL_FAILURE] (state, data) {
      console.log('GET_DOCUMENT_RENEWAL_FAILURE')
      state.documentRenewal = null
    },
    [GET_DOCUMENT_RENEWAL_SUCCESS] (state, data) {
      console.log('GET_DOCUMENT_RENEWAL_SUCCESS')
      state.documentRenewal = data.data.data
      if (data.callback) {
        data.callback()
      }
    },
    [CONFIRM_DOCUMENT_RENEWAL_FAILURE] (state, data) {
      console.log('CONFIRM_DOCUMENT_RENEWAL_FAILURE')
      state.documentRenewalNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.documentRenewalNotify = null
      }, constant.notifyShowTime.long)
    },
    [CONFIRM_DOCUMENT_RENEWAL_SUCCESS] (state, data) {
      console.log('CONFIRM_DOCUMENT_RENEWAL_SUCCESS')
      state.documentRenewalNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.documentRenewalNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    },
    [REJECT_DOCUMENT_RENEWAL_FAILURE] (state, data) {
      console.log('REJECT_DOCUMENT_RENEWAL_FAILURE')
      state.documentRenewalNotify = {message: data.error, danger: true}
      setTimeout(() => {
        state.documentRenewalNotify = null
      }, constant.notifyShowTime.long)
    },
    [REJECT_DOCUMENT_RENEWAL_SUCCESS] (state, data) {
      console.log('REJECT_DOCUMENT_RENEWAL_SUCCESS')
      state.documentRenewalNotify = {message: data.data.success, danger: false}
      setTimeout(() => {
        state.documentRenewalNotify = null
      }, constant.notifyShowTime.normal)
      if (data.callback) {
        data.callback()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/document-renewal.js